module.exports = __webpack_public_path__ + "3830d47be04eb3249c03c0ae7b4ff382.svg";